"use strict";

// const graphElementMaximizeModalCtrl = require("./graphElementMaximizeModalCtrl");

module.exports = function (graphDataFactory, myGraph, Form, Integration, $uibModal, $timeout, $rootScope, siteConfig) {
    var _this = this;
    _this.graphDataFactory = graphDataFactory;
    _this.siteConfig = siteConfig;
    this.footer = false;

    this.loading = true;

    Form.find({
        "filter": {
            "where": {
                "id": {
                    "inq":
                        myGraph.pages.flatMap(page => page.fields.filter(f => f.type == "datasource")).map(ds => ds.templateData.datasource.formId)
                }
            }
        }
    })
    .$promise.then(function (forms) {
        Integration.find()
        .$promise.then(function (integrations) {
            graphDataFactory.init(forms, myGraph, integrations);
            _this.forms = forms;
            _this.graph = myGraph;
            _this.integrations = integrations;
    
            _this.page = 0;
            _this.pageCount = _this.graph?.pages?.length || 0;
            _this.refreshID;
            _this.minute = 0;

            window.document.title = myGraph.name; // Window title - graph name
            
            _this.showFooter = !(localStorage.getItem('graphFooterOff') === "1" || localStorage.getItem('validationGraphHideNavBar') === "1") && !_this.graph.updateFooter;

            _this.loading = false;

        });
    });

    _this.windowInnerHeight = window.innerHeight; // for 'justify' element height calc

    _this.updateFilters = function (element) {
        clearTimeout(_this.refreshID);
        $rootScope.$broadcast("graph-reloadData-loading");
        graphDataFactory.cancelInFlightRequests();
        $timeout.cancel(_this.filtersDebounceId);
        _this.filtersDebounceId = $timeout(function () {
            if (element) {
                $rootScope.$broadcast("graph-select-filter", element);
            }
            graphDataFactory.refreshQueries();
            _this.autoReload();
        }, 350);
    };

    _this.changePage = (val) => {
        _this.page += val;
    };

    _this.changeMinute = (val) => {
        _this.minute += val;
        _this.autoReload();
    }

    _this.autoReload = () => {
        // console.log('_this.minute', _this.minute);
        if (_this.minute === 0) {
            clearTimeout(_this.refreshID);
            // console.log('clearTimeout')
        } else {
            // console.log('setTimeout')
            _this.refreshID = setTimeout(() => {
                // console.log(`Delayed for ${_this.minute} min`);
                _this.updateFilters();
            }, _this.minute * 60000);
        }
    };

    _this.openGraphMaximize = function (element, graphKind) {
        $uibModal.open({
            animation: true,
            templateUrl: "dashboard-graph-view/graphElementMaximizeModal.html",
            // controller: graphElementMaximizeModalCtrl,
            controller: require("./graphElementMaximizeModalCtrl"),
            controllerAs: "ctrl",
            windowClass: "graph-maximize-window",
            resolve: {
                modalElement: function () {
                    return element;
                },
                modalGraphKind: function () {
                    return graphKind;
                },
                modalUpdateFilters: function () {
                    return function () {
                        _this.updateFilters(element);
                    };
                },
                modalGraphId: function () {
                    return _this.graph && _this.graph.id;
                },
            },
        });
    };
};